const configuredApiBase = (process.env.REACT_APP_AUTH_URL || "").replace(/\/$/, "");
const developmentApiBase = `${window.location.protocol}//${window.location.hostname}:1338/api`;

export const API_BASE = configuredApiBase ||
  (window.location.port === "1337" ? developmentApiBase : `${window.location.origin}/api`);

export const buildApiUrl = (path = "") => {
  if (!path) return API_BASE;
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
};

export const resolveMediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    const url = new URL(path);
    if (window.location.protocol === "https:" && url.hostname === window.location.hostname) {
      url.protocol = "https:";
    }
    return url.toString();
  }
  const base = API_BASE.replace(/\/api\/?$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
};
